/* ═══════════════════════════════════════════════════════════════
   FORMA VALUE LABELS — the one place a stored forma value gets its
   plain-English wording. Review cards (`formaValueText`) and the Forma
   Studio's own pickers both read it, so the wording never drifts.
   A value with no entry here prints as stored.
   ═══════════════════════════════════════════════════════════════ */

/** The Blank page "Apply" rule, in picker order. */
export const BLANK_PAGE_CONDITIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'always', label: 'Always' },
  { value: 'whenOdd', label: 'When page count is odd' },
  { value: 'whenEven', label: 'When page count is even' },
];

const ALIGN: Record<string, string> = {
  left: 'Left',
  center: 'Centered',
  right: 'Right',
  justify: 'Justified',
};

const TEXT_CASE: Record<string, string> = {
  upper: 'All caps',
  title: 'Title case',
  sentence: 'Sentence case',
};

const NUMBER_FORMAT: Record<string, string> = {
  part_dash: 'PART 1 -',
  part_space: 'PART 1',
  '1.01': '1.01',
  '1.1': '1.1',
  '1)': '1)',
  '(1)': '(1)',
  'a)': 'a)',
  '(a)': '(a)',
  '(1)_8': '(1)',
  '1)_8': '1)',
  '(a)_9': '(a)',
  'a)_9': 'a)',
};

const DATE_FORMAT: Record<string, string> = {
  'M/d/yyyy': '1/5/2026',
  'MM/dd/yyyy': '01/05/2026',
  'yyyy/MM/dd': '2026/01/05',
  'MMMM d, yyyy': 'January 5, 2026',
  'MMM d, yyyy': 'Jan 5, 2026',
  'd MMMM yyyy': '5 January 2026',
  'MM-dd-yyyy': '01-05-2026',
  'yyyy-MM-dd': '2026-01-05',
};

/** Field name (the last path segment) → stored value → words. */
const BY_FIELD: Record<string, Record<string, string>> = {
  blankPageCondition: Object.fromEntries(BLANK_PAGE_CONDITIONS.map((o) => [o.value, o.label])),
  blankPageJustify: ALIGN,
  justify: ALIGN,
  align: ALIGN,
  textCase: TEXT_CASE,
  numberFormats: NUMBER_FORMAT,
  dateFormat: DATE_FORMAT,
};

/** Words for one stored string value of `field`, or undefined when unmapped. */
export function formaStringLabel(field: string, value: string): string | undefined {
  return BY_FIELD[field]?.[value];
}

/** Line spacing is a multiplier on disk; readers know Single / Double. */
export function lineSpacingLabel(n: number): string {
  if (n === 1) return 'Single';
  if (n === 2) return 'Double';
  return `${+n.toFixed(2)} lines`;
}
